export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_13.5264f290.jpg";